import { render, staticRenderFns } from "./ContentItemsList.vue?vue&type=template&id=dee8236e&scoped=true&"
import script from "./ContentItemsList.vue?vue&type=script&lang=js&"
export * from "./ContentItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ContentItemsList.vue?vue&type=style&index=0&id=dee8236e&prod&lang=scss&scoped=true&"
import style1 from "./ContentItemsList.vue?vue&type=style&index=1&id=dee8236e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee8236e",
  null
  
)

export default component.exports